import React, { useState, useEffect, useCallback } from 'react';
import { getUsuarioLogado, isLoggedIn, apiCallAuth, apiCall } from '../utils/auth';
import { useNavigate } from 'react-router-dom';
import '../sidebar/MinhaConta.css';
import './CadastrarUsuario.css';
import LoadingOverlay from './LoadingOverlay';
// IDs de Nível de Funcionário (TipoUsuarioLogin)
import BASE_URL from '../utils/api';
const NIVEL_GERENTE_TI = 6;
const NIVEL_GERENTE = 3;

// Lista de páginas do sistema para controle de acesso (sem Cadastrar/Gerenciar Funcionários - tratados separadamente)
const PAGINAS_SISTEMA = [
  { nome: 'Cliente', label: 'Clientes' },
  { nome: 'Fornecedor', label: 'Fornecedores' },
  { nome: 'Pessoas', label: 'Pessoas' },
  { nome: 'Agendamentos', label: 'Agendamentos' },
  { nome: 'Calendario', label: 'Calendário' },
  { nome: 'Oportunidade', label: 'Oportunidades' },
  { nome: 'Orcamento', label: 'Orçamentos' },
  { nome: 'Contrato', label: 'Contratos' },
  { nome: 'Vendas', label: 'Vendas' },
  { nome: 'VendasProdutos', label: 'Vendas de Produtos' },
  { nome: 'ContasPagar', label: 'Contas a Pagar' },
  { nome: 'ContasReceber', label: 'Contas a Receber' },
  { nome: 'NotaFiscal', label: 'Notas Fiscais' },
  { nome: 'Producao', label: 'Projeto' },
  { nome: 'ProjetoVisual', label: 'Projeto Visual' },
  { nome: 'Tarefas', label: 'Tarefas' },
  { nome: 'MateriaPrima', label: 'Matéria Prima' },
  { nome: 'ServicosTerceiros', label: 'Serviços de Terceiros' },
  { nome: 'Manutencao', label: 'Manutenção' },
  { nome: 'Garantia', label: 'Garantia' },
  { nome: 'RelacionamentoClientes', label: 'Relacionamento com Clientes' },
  { nome: 'EntregasProdutos', label: 'Entrega de Produtos' },
  { nome: 'EntregasServicos', label: 'Entrega de Serviços' },
  { nome: 'Prazos', label: 'Prazos' },
  { nome: 'Estoque', label: 'Estoque' },
  { nome: 'Produto', label: 'Produtos' },
  { nome: 'Grupo', label: 'Grupos' },
];

// Páginas especiais de gerenciamento de funcionários (só Gerente de TI)
const PAGINAS_FUNCIONARIOS = [
  { nome: 'CadastrarUsuario', label: 'Cadastrar Funcionários' },
  { nome: 'GerenciarFuncionarios', label: 'Gerenciar Funcionários' },
];

export default function CadastrarUsuario() {
  const navigate = useNavigate();
  const [showPopup, setShowPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingTipos, setLoadingTipos] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  
  // Popup de adicionar cargo
  const [showCargoPopup, setShowCargoPopup] = useState(false);
  const [novoCargo, setNovoCargo] = useState('');
  const [loadingCargo, setLoadingCargo] = useState(false);
  const [cargoError, setCargoError] = useState('');
  const [cargoSuccess, setCargoSuccess] = useState('');

  // Popup de adicionar nível
  const [showNivelPopup, setShowNivelPopup] = useState(false);
  const [novoNivel, setNovoNivel] = useState('');
  const [loadingNivel, setLoadingNivel] = useState(false);
  const [nivelError, setNivelError] = useState('');
  const [nivelSuccess, setNivelSuccess] = useState('');
  
  // Dados do usuário logado
  const [usuarioLogado, setUsuarioLogado] = useState(null);
  
  // Lista de tipos de usuário disponíveis (cargo)
  const [tiposUsuario, setTiposUsuario] = useState([]);
  
  // Lista de níveis de funcionário (TipoUsuarioLogin)
  const [niveisUsuario, setNiveisUsuario] = useState([]);
  const [loadingNiveis, setLoadingNiveis] = useState(false);
  
  // Lista de funcionários criados
  const [funcionarios, setFuncionarios] = useState([]);
  const [loadingFuncionarios, setLoadingFuncionarios] = useState(false);

  // Permissões de páginas (controle de acesso)
  const [paginasSelecionadas, setPaginasSelecionadas] = useState(
    PAGINAS_SISTEMA.reduce((acc, pagina) => ({ ...acc, [pagina.nome]: true }), {})
  );
  const [todosSelecionados, setTodosSelecionados] = useState(true);
  
  // Permissões de páginas de funcionários (para Gerente não TI)
  const [permissoesFuncionarios, setPermissoesFuncionarios] = useState({
    CadastrarUsuario: false,
    GerenciarFuncionarios: false
  });
  
  // Controle do botão "Permitir Gerenciamento" para Gerentes
  const [permitirGerenciamento, setPermitirGerenciamento] = useState(false);

  // Form data para novo usuário
  const [formData, setFormData] = useState({
    login: '',
    senha: '',
    confirmarSenha: '',
    tipoPessoa: '',
    cpfEmpregado: '',
    tipoUsuarioId: '',
    tipoUsuarioLoginId: '',
    nomeUsuario: '',
    email: '',
    telefone: ''
  });

  // Carregar dados do usuário logado ao montar
  useEffect(() => {
    if (isLoggedIn()) {
      const user = getUsuarioLogado();
      setUsuarioLogado(user);
      // Pré-preencher tipoPessoa com base no usuário logado
      if (user) {
        setFormData(prev => ({
          ...prev,
          tipoPessoa: user.tipoPessoa || ''
        }));
      }
    }
  }, []);

  // Carregar tipos de usuário (cargo)
  const carregarTiposUsuario = useCallback(async () => {
    try {
      setLoadingTipos(true);
      const tipos = await apiCall('TipoUsuario');
      console.log('✅ TipoUsuario carregados:', tipos?.length || 0, 'itens');
      setTiposUsuario(Array.isArray(tipos) ? tipos : []);
    } catch (err) {
      console.error('Erro ao carregar tipos de usuário:', err);
    } finally {
      setLoadingTipos(false);
    }
  }, []);

  // Carregar níveis de funcionário (TipoUsuarioLogin) - excluindo CEO (ID 5)
  const carregarNiveisUsuario = useCallback(async () => {
    try {
      setLoadingNiveis(true);
      const niveis = await apiCall('TipoUsuarioLogin');
      // Filtrar para excluir o CEO (ID 5)
      const niveisFiltrados = Array.isArray(niveis) 
        ? niveis.filter(n => n.id !== 5 && n.Id !== 5)
        : [];
      setNiveisUsuario(niveisFiltrados);
    } catch (err) {
      console.error('Erro ao carregar níveis de usuário:', err);
    } finally {
      setLoadingNiveis(false);
    }
  }, []);

  // Carregar funcionários vinculados ao usuário logado
  const carregarFuncionarios = useCallback(async () => {
    if (!usuarioLogado) return;
    
    try {
      setLoadingFuncionarios(true);
      let endpoint = '';
      
      // Buscar funcionários pelo CNPJ ou CPF do usuário logado
      if (usuarioLogado.tipoPessoa === 'PJ' && usuarioLogado.cnpjUsuario) {
        endpoint = `UsuarioSistema/por-cnpj-empresa/${usuarioLogado.cnpjUsuario}`;
      } else if (usuarioLogado.tipoPessoa === 'PF' && usuarioLogado.cpfUsuario) {
        endpoint = `UsuarioSistema/por-cpf-vinculado/${usuarioLogado.cpfUsuario}`;
      }
      
      if (endpoint) {
        const token = localStorage.getItem('authToken');
        const headers = {};
        if (token) headers['Authorization'] = `Bearer ${token}`;
        const response = await fetch(`${BASE_URL}/${endpoint}`, { headers });
        if (response.ok) {
          const data = await response.json();
          // Filtrar para não mostrar o próprio usuário logado
          const funcionariosFiltrados = Array.isArray(data) 
            ? data.filter(f => f.id !== usuarioLogado.id)
            : [];
          setFuncionarios(funcionariosFiltrados);
        } else {
          // Se não encontrar, tenta carregar todos os usuários com CPFEmpregado
          setFuncionarios([]);
        }
      }
    } catch (err) {
      console.error('Erro ao carregar funcionários:', err);
      setFuncionarios([]);
    } finally {
      setLoadingFuncionarios(false);
    }
  }, [usuarioLogado]);

  useEffect(() => {
    carregarTiposUsuario();
  }, [carregarTiposUsuario]);

  useEffect(() => {
    carregarNiveisUsuario();
  }, [carregarNiveisUsuario]);

  useEffect(() => {
    carregarFuncionarios();
  }, [carregarFuncionarios]);

  // Tour: abrir popup de cadastro quando AjudaWidget disparar evento
  useEffect(() => {
    const openPopupHandler = () => {
      setShowPopup(true);
      setError('');
      setSuccess('');
      setShowPassword(false);
      setFormData({
        login: '',
        senha: '',
        confirmarSenha: '',
        tipoPessoa: '',
        cpfEmpregado: '',
        tipoUsuarioId: '',
        tipoUsuarioLoginId: '',
        nomeUsuario: '',
        email: '',
        telefone: ''
      });
      setTodosSelecionados(true);
      setPaginasSelecionadas(PAGINAS_SISTEMA.reduce((acc, p) => ({ ...acc, [p.nome]: true }), {}));
      setPermissoesFuncionarios({ CadastrarUsuario: false, GerenciarFuncionarios: false });
      setPermitirGerenciamento(false);
    };

    // Tour step 3: popup já está aberto, apenas seleciona nível Gerente para mostrar permissões
    const setNivelGerenteHandler = () => {
      setFormData(prev => ({ ...prev, tipoUsuarioLoginId: String(NIVEL_GERENTE) }));
    };

    window.addEventListener('tour-open-popup-cadastrar', openPopupHandler);
    window.addEventListener('tour-set-nivel-gerente', setNivelGerenteHandler);
    return () => {
      window.removeEventListener('tour-open-popup-cadastrar', openPopupHandler);
      window.removeEventListener('tour-set-nivel-gerente', setNivelGerenteHandler);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps


  const handlePaginaChange = (nomePagina) => {
    const nivelSelecionado = parseInt(formData.tipoUsuarioLoginId, 10);
    // Se for Gerente de TI, não permite alterar
    if (nivelSelecionado === NIVEL_GERENTE_TI) {
      return;
    }
    
    setPaginasSelecionadas(prev => {
      const novoEstado = { ...prev, [nomePagina]: !prev[nomePagina] };
      // Verificar se todos estão selecionados para atualizar o checkbox "Todos"
      const todosMarcados = PAGINAS_SISTEMA.every(p => novoEstado[p.nome]);
      setTodosSelecionados(todosMarcados);
      return novoEstado;
    });
  };

  // Função para marcar/desmarcar todos
  const handleTodosChange = () => {
    const nivelSelecionado = parseInt(formData.tipoUsuarioLoginId, 10);
    // Se for Gerente de TI, não permite alterar
    if (nivelSelecionado === NIVEL_GERENTE_TI) {
      return;
    }
    
    const novoValor = !todosSelecionados;
    setTodosSelecionados(novoValor);
    setPaginasSelecionadas(
      PAGINAS_SISTEMA.reduce((acc, pagina) => ({ ...acc, [pagina.nome]: novoValor }), {})
    );
  };

  // Atualizar permissões quando o nível do funcionário mudar
  const atualizarPermissoesPorNivel = (nivelId) => {
    const nivel = parseInt(nivelId, 10);
    
    if (nivel === NIVEL_GERENTE_TI) {
      // Gerente de TI: tudo marcado e bloqueado
      setTodosSelecionados(true);
      setPaginasSelecionadas(
        PAGINAS_SISTEMA.reduce((acc, pagina) => ({ ...acc, [pagina.nome]: true }), {})
      );
    } else if (nivel === NIVEL_GERENTE) {
      // Gerente: tudo marcado mas permissões de funcionários desmarcadas por padrão
      setTodosSelecionados(true);
      setPaginasSelecionadas(
        PAGINAS_SISTEMA.reduce((acc, pagina) => ({ ...acc, [pagina.nome]: true }), {})
      );
      setPermissoesFuncionarios({ CadastrarUsuario: false, GerenciarFuncionarios: false });
    }
    // Para outros níveis, mantém as seleções atuais
  };

  // Toggle permissão de funcionário (para Gerente não TI)
  // Sempre marca/desmarca ambas as permissões juntas
  const handlePermissaoFuncionarioChange = (nomePagina) => {
    // Esta função não é mais usada diretamente, mantida para compatibilidade
    setPermissoesFuncionarios(prev => ({
      ...prev,
      [nomePagina]: !prev[nomePagina]
    }));
  };
  
  // Toggle do botão "Permitir Gerenciamento" - marca/desmarca ambas as permissões
  const handlePermitirGerenciamentoToggle = () => {
    const novoValor = !permitirGerenciamento;
    setPermitirGerenciamento(novoValor);
    setPermissoesFuncionarios({
      CadastrarUsuario: novoValor,
      GerenciarFuncionarios: novoValor
    });
  };

  // Resetar permissões para o padrão (todos marcados)
  const resetarPermissoes = () => {
    setTodosSelecionados(true);
    setPaginasSelecionadas(
      PAGINAS_SISTEMA.reduce((acc, pagina) => ({ ...acc, [pagina.nome]: true }), {})
    );
    setPermissoesFuncionarios({ CadastrarUsuario: false, GerenciarFuncionarios: false });
    setPermitirGerenciamento(false);
  };

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    let cleanValue = value;
    
    // Proibir espaços em login e senhas
    if (name === 'login' || name === 'senha' || name === 'confirmarSenha') {
      if (/\s/.test(value)) {
        cleanValue = value.replace(/\s/g, '');
        setError('Espaços não são permitidos em login ou senha.');
        setTimeout(() => setError(''), 2200);
      }
    }
    
    // CPF: aceitar apenas números
    if (name === 'cpfEmpregado') {
      cleanValue = value.replace(/\D/g, '');
    }
    
    // Quando mudar o nível do funcionário, atualizar permissões
    if (name === 'tipoUsuarioLoginId') {
      atualizarPermissoesPorNivel(cleanValue);
    }
    
    setFormData(prev => ({ ...prev, [name]: cleanValue }));
  };

  // Validação de senha
  const passwordRules = (pwd) => {
    const rules = [
      { id: 'length', label: 'Mínimo 6 caracteres', ok: pwd && pwd.length >= 6 },
      { id: 'composition', label: 'Contém letras, números e caractere especial', ok: pwd && /[A-Za-z]/.test(pwd) && /\d/.test(pwd) && /[^A-Za-z0-9]/.test(pwd) },
    ];
    return rules;
  };

  const toggleShow = () => setShowPassword(s => !s);

  // Abrir popup de adicionar cargo
  const handleOpenCargoPopup = () => {
    setShowCargoPopup(true);
    setNovoCargo('');
    setCargoError('');
    setCargoSuccess('');
  };

  // Fechar popup de cargo
  const handleCloseCargoPopup = () => {
    setShowCargoPopup(false);
    setNovoCargo('');
    setCargoError('');
    setCargoSuccess('');
  };

  // Criar novo cargo
  const handleCreateCargo = async (e) => {
    e.preventDefault();
    setCargoError('');
    setCargoSuccess('');

    if (!novoCargo.trim()) {
      setCargoError('Digite o nome do cargo.');
      return;
    }

    setLoadingCargo(true);

    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${BASE_URL}/TipoUsuario`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ descricaoTpUsuario: novoCargo.trim() })
      });

      if (!response.ok) {
        const text = await response.text();
        throw new Error(text || 'Erro ao criar cargo');
      }

      setCargoSuccess('Cargo criado com sucesso!');
      
      // Recarregar lista de cargos
      await carregarTiposUsuario();
      
      // Fecha imediatamente para impedir criação de múltiplos cargos
      handleCloseCargoPopup();

    } catch (err) {
      console.error('Erro ao criar cargo:', err);
      setCargoError('Erro ao criar cargo: ' + (err.message || String(err)));
    } finally {
      setLoadingCargo(false);
    }
  };

  // Abrir popup de adicionar nível
  const handleOpenNivelPopup = () => {
    setShowNivelPopup(true);
    setNovoNivel('');
    setNivelError('');
    setNivelSuccess('');
  };

  // Fechar popup de nível
  const handleCloseNivelPopup = () => {
    setShowNivelPopup(false);
    setNovoNivel('');
    setNivelError('');
    setNivelSuccess('');
  };

  // Criar novo nível
  const handleCreateNivel = async (e) => {
    e.preventDefault();
    setNivelError('');
    setNivelSuccess('');

    if (!novoNivel.trim()) {
      setNivelError('Digite o nome do nível.');
      return;
    }

    setLoadingNivel(true);

    try {
      const token = localStorage.getItem('authToken');
      const response = await fetch(`${BASE_URL}/TipoUsuarioLogin`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ descricao: novoNivel.trim() })
      });

      if (!response.ok) {
        const text = await response.text();
        throw new Error(text || 'Erro ao criar nível');
      }

      setNivelSuccess('Nível criado com sucesso!');
      
      // Recarregar lista de níveis
      await carregarNiveisUsuario();
      
      // Fecha imediatamente para impedir criação de múltiplos níveis
      handleCloseNivelPopup();

    } catch (err) {
      console.error('Erro ao criar nível:', err);
      setNivelError('Erro ao criar nível: ' + (err.message || String(err)));
    } finally {
      setLoadingNivel(false);
    }
  };

  // Abrir popup
  const handleOpenPopup = () => {
    setShowPopup(true);
    setError('');
    setSuccess('');
    setShowPassword(false); // Sempre começar com senha escondida
    // Reset form com tipoPessoa do usuário logado
    setFormData({
      login: '',
      senha: '',
      confirmarSenha: '',
      tipoPessoa: usuarioLogado?.tipoPessoa || '',
      cpfEmpregado: '',
      tipoUsuarioId: '',
      tipoUsuarioLoginId: '',
      nomeUsuario: '',
      email: '',
      telefone: ''
    });
    // Resetar permissões para todos marcados
    resetarPermissoes();
  };

  // Fechar popup
  const handleClosePopup = () => {
    setShowPopup(false);
    setError('');
    setSuccess('');
  };

  // Verificar se login já existe
  const verificarLoginExiste = async (login) => {
    try {
      const token = localStorage.getItem('authToken');
      const headers = {};
      if (token) headers['Authorization'] = `Bearer ${token}`;
      const resp = await fetch(`${BASE_URL}/UsuarioSistema/por-login/${encodeURIComponent(login)}`, { headers });
      return resp.status === 200;
    } catch {
      return false;
    }
  };

  // Criar conta do funcionário
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    // Validações
    const rules = passwordRules(formData.senha);
    const validPassword = rules.every(r => r.ok);

    if (!formData.login || !formData.senha || !formData.confirmarSenha) {
      setError('Preencha login e senha.');
      return;
    }

    if (/\s/.test(formData.login) || /\s/.test(formData.senha)) {
      setError('Espaços não são permitidos em login ou senha.');
      return;
    }

    if (!validPassword) {
      setError('A senha não atende aos requisitos.');
      return;
    }

    if (formData.senha !== formData.confirmarSenha) {
      setError('A senha e a confirmação devem ser iguais.');
      return;
    }

    if (!formData.cpfEmpregado || formData.cpfEmpregado.length !== 11) {
      setError('CPF do Empregado deve ter 11 dígitos.');
      return;
    }

    if (!formData.tipoUsuarioId) {
      setError('Selecione o cargo do funcionário.');
      return;
    }

    if (!formData.tipoUsuarioLoginId) {
      setError('Selecione o nível do funcionário.');
      return;
    }

    if (!formData.nomeUsuario || !formData.email) {
      setError('Nome e email são obrigatórios.');
      return;
    }

    setLoading(true);

    try {
      // Montar payload para o endpoint cadastrar-funcionario
      // Este endpoint faz tudo: UsuarioSistema + DadosUsuario + Pessoa + UsuarioSistemaTenant
      // Reaproveita o CNPJ/CPF da instância via JWT token
      const payload = {
        login: formData.login,
        senha: formData.senha,
        cpf: formData.cpfEmpregado,
        nome: formData.nomeUsuario,
        email: formData.email,
        telefone: formData.telefone || '',
        tipoUsuarioLoginId: formData.tipoUsuarioLoginId ? parseInt(formData.tipoUsuarioLoginId, 10) : null,
        tipoUsuarioId: formData.tipoUsuarioId ? parseInt(formData.tipoUsuarioId, 10) : null,
        empresaContaId: usuarioLogado?.empresaContaId || null
      };

      console.log('📤 Payload cadastrar-funcionario:', payload);

      // POST via endpoint autenticado que cria tudo na instância + banco central
      const token = localStorage.getItem('authToken');
      const respFuncionario = await fetch(`${BASE_URL}/UsuarioSistema/cadastrar-funcionario`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });

      if (!respFuncionario.ok) {
        const errorData = await respFuncionario.json().catch(() => null);
        const errorText = errorData?.mensagem || (await respFuncionario.text()) || 'Erro ao cadastrar funcionário';
        throw new Error(typeof errorText === 'string' ? errorText : 'Erro ao cadastrar funcionário');
      }

      const resultado = await respFuncionario.json();
      const usuarioSistemaId = resultado.usuario?.id || resultado.usuario?.Id;

      console.log('✅ Funcionário cadastrado:', resultado);

      // POST PaginaSistema - Salvar permissões de acesso às páginas
      if (usuarioSistemaId) {
        let paginasLiberadas = PAGINAS_SISTEMA
          .filter(pagina => paginasSelecionadas[pagina.nome])
          .map(pagina => pagina.nome);

        // Se for Gerente de TI, adicionar todas as páginas de funcionários
        const nivelSelecionado = parseInt(formData.tipoUsuarioLoginId, 10);
        if (nivelSelecionado === NIVEL_GERENTE_TI) {
          paginasLiberadas = [...paginasLiberadas, ...PAGINAS_FUNCIONARIOS.map(p => p.nome)];
        } else if (nivelSelecionado === NIVEL_GERENTE) {
          // Se for Gerente, adicionar apenas as páginas de funcionários que foram marcadas
          PAGINAS_FUNCIONARIOS.forEach(p => {
            if (permissoesFuncionarios[p.nome]) {
              paginasLiberadas.push(p.nome);
            }
          });
        }

        if (paginasLiberadas.length > 0) {
          const permissoesPayload = {
            paginas: paginasLiberadas,
            usuarioSistemaId: usuarioSistemaId
          };

          console.log('📤 Salvando permissões:', permissoesPayload);

          const respPermissoes = await fetch(`${BASE_URL}/PaginaSistema/bulk`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
            body: JSON.stringify(permissoesPayload)
          });

          if (!respPermissoes.ok) {
            const text = await respPermissoes.text();
            console.warn('Aviso ao salvar permissões:', text);
          } else {
            console.log('✅ Permissões salvas com sucesso!');
          }
        }
      }

      setSuccess('Funcionário cadastrado com sucesso!');
      
      // Recarregar lista de funcionários
      setTimeout(() => {
        carregarFuncionarios();
        handleClosePopup();
      }, 1500);

    } catch (err) {
      console.error('Erro ao criar conta:', err);
      setError('Erro ao criar conta: ' + (err.message || String(err)));
    } finally {
      setLoading(false);
    }
  };

  // Obter descrição do cargo do funcionário
  const getTipoUsuarioDescricao = (tipoId) => {
    const tipo = tiposUsuario.find(t => (t.id || t.Id) === tipoId);
    return tipo?.descricaoTpUsuario || tipo?.DescricaoTpUsuario || 'N/A';
  };

  // Obter descrição do nível do funcionário
  const getNivelUsuarioDescricao = (nivelId) => {
    const nivel = niveisUsuario.find(n => (n.id || n.Id) === nivelId);
    return nivel?.descricao || nivel?.Descricao || 'N/A';
  };

  if (!isLoggedIn()) {
    return (
      <div className="minha-conta-container">
        <div className="minha-conta-card">
          <p>Você precisa estar logado para acessar esta página.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="cadastrar-usuario-container" style={{ position: 'relative' }}>
      {/* Loading Global */}
      <LoadingOverlay isLoading={loading} message="Cadastrando funcionário..." />
      
      <button
        onClick={() => navigate('/sidebar/Configuracoes')}
        className="planos-btn-voltar"
        style={{ position: 'absolute', top: 10, left: 10, zIndex: 20 }}
        title="Voltar para Configurações"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M15 18l-6-6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
        Voltar
      </button>
      <div className="cadastrar-usuario-card">
        <div className="cadastrar-usuario-header">
          <h2>Cadastrar Funcionário</h2>
          <p>Adicione novas contas de funcionários</p>
        </div>

        {/* Botão Adicionar Conta */}
        <button className="btn-adicionar-conta" onClick={handleOpenPopup}>
          <span className="btn-icon">+</span>
          Adicionar Nova Conta
        </button>

        <button
          className="btn-ver-funcionarios"
          onClick={() => navigate('/sidebar/GerenciarFuncionarios')}
        >
          Gerenciar Funcionarios
        </button>

        
      </div>

      {/* Popup Modal */}
      {showPopup && (
        <div className="popup-overlay" onClick={handleClosePopup}>
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            <button className="popup-close" onClick={handleClosePopup}>×</button>
            
            <div className="popup-header">
              <h3>Cadastrar Novo Funcionário</h3>
              <p>Preencha os dados para criar uma nova conta</p>
            </div>

            {error && <div className="popup-error">⚠️ {error}</div>}
            {success && <div className="popup-success">✓ {success}</div>}

            <form onSubmit={handleSubmit} className="popup-form">
              {/* Login e Senha */}
              <div className="form-section">
                <h4>Dados de Acesso</h4>
                
                <div className="form-group">
                  <label htmlFor="login">Login</label>
                  <input 
                    id="login" 
                    name="login" 
                    value={formData.login} 
                    onChange={handleChange} 
                    placeholder="Digite o login"
                    required 
                    disabled={loading} 
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="senha">Senha</label>
                  <div className="input-with-icon">
                    <input 
                      id="senha" 
                      name="senha" 
                      type={showPassword ? 'text' : 'password'} 
                      value={formData.senha} 
                      onChange={handleChange} 
                      placeholder="Digite a senha"
                      required 
                      disabled={loading} 
                    />
                    <button type="button" onClick={toggleShow} className="password-toggle" aria-label="Mostrar senha">
                      {showPassword ? (
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                          <path d="M3 3l18 18" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M17.94 17.94A10.95 10.95 0 0 1 12 20c-5 0-9.27-3-11-8 1.1-2.9 3.2-5.2 5.7-6.6" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M9.88 9.88a3 3 0 0 0 4.24 4.24" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      ) : (
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                          <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <circle cx="12" cy="12" r="3" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      )}
                    </button>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="confirmarSenha">Confirmar Senha</label>
                  <div className="input-with-icon">
                    <input 
                      id="confirmarSenha" 
                      name="confirmarSenha" 
                      type={showPassword ? 'text' : 'password'} 
                      value={formData.confirmarSenha} 
                      onChange={handleChange} 
                      placeholder="Confirme a senha"
                      required 
                      disabled={loading} 
                    />
                    <button type="button" onClick={toggleShow} className="password-toggle" aria-label="Mostrar senha">
                      {showPassword ? (
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                          <path d="M3 3l18 18" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M17.94 17.94A10.95 10.95 0 0 1 12 20c-5 0-9.27-3-11-8 1.1-2.9 3.2-5.2 5.7-6.6" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M9.88 9.88a3 3 0 0 0 4.24 4.24" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      ) : (
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden>
                          <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                          <circle cx="12" cy="12" r="3" stroke="#555" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      )}
                    </button>
                  </div>
                </div>

                <ul className="password-rules">
                  {passwordRules(formData.senha).map(rule => (
                    <li key={rule.id} className={`password-rule ${rule.ok ? 'valid' : 'invalid'}`}>
                      {rule.ok ? '✓' : '●'} {rule.label}
                    </li>
                  ))}
                </ul>
              </div>

              {/* Tipo Pessoa e CPF Empregado */}
              <div className="form-section">
                <h4>Dados da Empresa/Pessoa</h4>
                
                <div className="form-group">
                  <label htmlFor="tipoPessoa">Tipo de Pessoa</label>
                  <select 
                    id="tipoPessoa" 
                    name="tipoPessoa" 
                    value={formData.tipoPessoa} 
                    disabled={true} // Bloqueado - herda do usuário logado
                    className="input-disabled"
                  >
                    <option value="">Selecione...</option>
                    <option value="PF">Pessoa Física (PF)</option>
                    <option value="PJ">Pessoa Jurídica (PJ)</option>
                  </select>
                  <small className="form-hint">
                    {formData.tipoPessoa === 'PJ' 
                      ? `Herdando CNPJ: ${usuarioLogado?.cnpjUsuario || 'N/A'}` 
                      : `Herdando CPF: ${usuarioLogado?.cpfUsuario || 'N/A'}`}
                  </small>
                </div>

                <div className="form-group">
                  <label htmlFor="cpfEmpregado">CPF do Empregado *</label>
                  <input 
                    id="cpfEmpregado" 
                    name="cpfEmpregado" 
                    value={formData.cpfEmpregado} 
                    onChange={handleChange} 
                    placeholder="00000000000"
                    maxLength="11"
                    required 
                    disabled={loading} 
                  />
                  <small className="form-hint">Digite apenas os 11 números do CPF</small>
                </div>
              </div>

              {/* Perfil de Acesso */}
              <div className="form-section">
                <h4>Perfil de Acesso</h4>
                
                <div className="form-group">
                  <label htmlFor="tipoUsuarioId">Cargo Funcionário *</label>
                  <select 
                    id="tipoUsuarioId" 
                    name="tipoUsuarioId" 
                    value={formData.tipoUsuarioId} 
                    onChange={(e) => {
                      console.log('🎯 SELECT CARGO - Valor selecionado:', e.target.value);
                      handleChange(e);
                    }}
                    required 
                    disabled={loading || loadingTipos}
                  >
                    <option value="">Selecione o cargo...</option>
                    {tiposUsuario.map(tipo => {
                      const tipoId = tipo.id || tipo.Id;
                      const tipoDescricao = tipo.descricaoTpUsuario || tipo.DescricaoTpUsuario;
                      return (
                        <option key={tipoId} value={String(tipoId)}>
                          {tipoDescricao}
                        </option>
                      );
                    })}
                  </select>
                  <button 
                    type="button" 
                    className="btn-adicionar-cargo" 
                    onClick={handleOpenCargoPopup}
                    disabled={loading}
                  >
                    + Adicionar Cargo
                  </button>
                </div>

                <div className="form-group">
                  <label htmlFor="tipoUsuarioLoginId">Nível Funcionário *</label>
                  <select 
                    id="tipoUsuarioLoginId" 
                    name="tipoUsuarioLoginId" 
                    value={formData.tipoUsuarioLoginId} 
                    onChange={handleChange}
                    required 
                    disabled={loading || loadingNiveis}
                  >
                    <option value="">Selecione o nível...</option>
                    {niveisUsuario.map(nivel => {
                      const nivelId = nivel.id || nivel.Id;
                      const nivelDescricao = nivel.descricao || nivel.Descricao;
                      return (
                        <option key={nivelId} value={String(nivelId)}>
                          {nivelDescricao}
                        </option>
                      );
                    })}
                  </select>
                  <button 
                    type="button" 
                    className="btn-adicionar-cargo" 
                    onClick={handleOpenNivelPopup}
                    disabled={loading}
                  >
                    + Adicionar Nível
                  </button>
                </div>
              </div>

              {/* Dados do Usuário */}
              <div className="form-section">
                <h4>Dados Pessoais</h4>
                
                <div className="form-group">
                  <label htmlFor="nomeUsuario">Nome Completo *</label>
                  <input 
                    id="nomeUsuario" 
                    name="nomeUsuario" 
                    value={formData.nomeUsuario} 
                    onChange={handleChange} 
                    placeholder="Nome do funcionário"
                    required 
                    disabled={loading} 
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email">E-mail *</label>
                  <input 
                    id="email" 
                    name="email" 
                    type="email"
                    value={formData.email} 
                    onChange={handleChange} 
                    placeholder="email@exemplo.com"
                    required 
                    disabled={loading} 
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="telefone">Telefone</label>
                  <input 
                    id="telefone" 
                    name="telefone" 
                    value={formData.telefone} 
                    onChange={handleChange} 
                    placeholder="(00) 00000-0000"
                    disabled={loading} 
                  />
                </div>
              </div>

              {/* Permissões de Acesso às Páginas - SÓ APARECE SE SELECIONOU UM NÍVEL */}
              {formData.tipoUsuarioLoginId && (
                <div className="form-section">
                  <h4>🔐 Permissões de Acesso</h4>
                  {(() => {
                    const nivelSelecionado = parseInt(formData.tipoUsuarioLoginId, 10);
                    const isGerenteTI = nivelSelecionado === NIVEL_GERENTE_TI;
                    const isGerente = nivelSelecionado === NIVEL_GERENTE;
                    
                    return (
                      <>
                        <p style={{ fontSize: 13, color: '#333', marginBottom: 12 }}>
                          {isGerenteTI 
                            ? 'Gerente de TI: Acesso total a todas as páginas'
                            : isGerente 
                              ? 'Gerente: Selecione se terá acesso ao gerenciamento de funcionários'
                              : 'Selecione as páginas que o funcionário poderá acessar no sistema'
                          }
                        </p>

                        {/* Seção de Gerenciamento de Funcionários - ACIMA DO SELECIONAR TODOS */}
                        {/* Para Gerente de TI: marcado e bloqueado */}
                        {isGerenteTI && (
                          <div style={{ marginBottom: 16 }}>
                            <h5 style={{ color: '#333', marginBottom: 8, fontSize: 14 }}>
                              🔧 Gerenciamento de Funcionários (exclusivo Gerente de TI)
                            </h5>
                            <div style={{
                              display: 'grid',
                              gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                              gap: 8,
                            }}>
                              {PAGINAS_FUNCIONARIOS.map(pagina => (
                                <div 
                                  key={pagina.nome}
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    padding: '8px 10px',
                                    background: '#fff3e0',
                                    borderRadius: 6,
                                    border: '1px solid #ffcc80'
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    checked={true}
                                    disabled={true}
                                    style={{ 
                                      width: 16, 
                                      height: 16, 
                                      cursor: 'not-allowed',
                                      accentColor: 'rgb(235, 133, 0)',
                                      filter: 'hue-rotate(0deg) brightness(1.1)'
                                    }}
                                  />
                                  <label style={{ fontSize: 13, color: '#333', flex: 1 }}>
                                    {pagina.label}
                                  </label>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}

                        {/* Para Gerente (não TI): pode escolher, desmarcado por padrão */}
                        {isGerente && (
                          <div style={{ marginBottom: 16 }}>
                            <h5 style={{ color: '#333', marginBottom: 8, fontSize: 14 }}>
                              🔧 Gerenciamento de Funcionários
                            </h5>
                            
                            {/* Botão Permitir Gerenciamento */}
                            <div style={{ marginBottom: 12 }}>
                              <button
                                type="button"
                                onClick={handlePermitirGerenciamentoToggle}
                                disabled={loading}
                                style={{
                                  padding: '8px 16px',
                                  background: permitirGerenciamento ? '#4CAF50' : '#f5f5f5',
                                  color: permitirGerenciamento ? 'white' : '#666',
                                  border: `2px solid ${permitirGerenciamento ? '#4CAF50' : '#ddd'}`,
                                  borderRadius: 6,
                                  fontSize: 13,
                                  fontWeight: 500,
                                  cursor: loading ? 'not-allowed' : 'pointer',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: 6,
                                  transition: 'all 0.2s ease'
                                }}
                              >
                                <span style={{ fontSize: 16 }}>{permitirGerenciamento ? '✓' : '○'}</span>
                                Permitir Gerenciamento
                              </button>
                            </div>
                            
                            <div style={{
                              display: 'grid',
                              gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                              gap: 8,
                            }}>
                              {PAGINAS_FUNCIONARIOS.map(pagina => (
                                <div 
                                  key={pagina.nome}
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 8,
                                    padding: '8px 10px',
                                    background: permissoesFuncionarios[pagina.nome] ? '#fff3e0' : '#f9f9f9',
                                    borderRadius: 6,
                                    border: `1px solid ${permissoesFuncionarios[pagina.nome] ? '#ffcc80' : '#ddd'}`,
                                    opacity: permitirGerenciamento ? 1 : 0.6
                                  }}
                                >
                                  <input
                                    type="checkbox"
                                    id={`perm-func-${pagina.nome}`}
                                    checked={permissoesFuncionarios[pagina.nome]}
                                    disabled={true}
                                    style={{ 
                                      width: 16, 
                                      height: 16, 
                                      cursor: 'not-allowed',
                                      accentColor: 'rgb(235, 133, 0)',
                                      filter: 'hue-rotate(0deg) brightness(1.1)'
                                    }}
                                  />
                                  <label 
                                    style={{ fontSize: 13, color: '#333', flex: 1 }}
                                  >
                                    {pagina.label}
                                  </label>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                        
                        {/* Checkbox Todos */}
                        <div className="permissoes-todos" style={{ 
                          marginBottom: 16, 
                          padding: '10px 14px', 
                          background: todosSelecionados ? '#fff3e0' : 'white', 
                          borderRadius: 8,
                          border: `1px solid ${todosSelecionados ? '#ffcc80' : '#ddd'}`,
                          display: 'flex',
                          alignItems: 'center',
                          gap: 10
                        }}>
                          <input
                            type="checkbox"
                            id="todos-permissoes"
                            checked={todosSelecionados}
                            onChange={handleTodosChange}
                            disabled={loading || isGerenteTI}
                            style={{ 
                              width: 18, 
                              height: 18, 
                              cursor: isGerenteTI ? 'not-allowed' : 'pointer',
                              accentColor: 'rgb(235, 133, 0)',
                              filter: 'hue-rotate(0deg) brightness(1.1)'
                            }}
                          />
                          <label 
                            htmlFor="todos-permissoes" 
                            style={{ 
                              fontWeight: 600, 
                              color: '#333', 
                              cursor: isGerenteTI ? 'not-allowed' : 'pointer',
                              userSelect: 'none'
                            }}
                          >
                            Selecionar Todos {isGerenteTI && '(bloqueado)'}
                          </label>
                        </div>

                        {/* Grid de Permissões */}
                        <div className="permissoes-grid" style={{
                          display: 'grid',
                          gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                          gap: 8,
                          maxHeight: 280,
                          overflowY: 'auto',
                          padding: '8px 4px',
                          border: '1px solid #e0e0e0',
                          borderRadius: 8,
                          background: '#fafafa'
                        }}>
                          {PAGINAS_SISTEMA.map(pagina => (
                            <div 
                              key={pagina.nome}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 8,
                                padding: '8px 10px',
                                background: paginasSelecionadas[pagina.nome] ? '#fff3e0' : 'white',
                                borderRadius: 6,
                                border: `1px solid ${paginasSelecionadas[pagina.nome] ? '#ffcc80' : '#ddd'}`
                              }}
                            >
                              <input
                                type="checkbox"
                                id={`perm-${pagina.nome}`}
                                checked={paginasSelecionadas[pagina.nome]}
                                onChange={() => handlePaginaChange(pagina.nome)}
                                disabled={loading || isGerenteTI}
                                style={{ 
                                  width: 16, 
                                  height: 16, 
                                  cursor: isGerenteTI ? 'not-allowed' : 'pointer',
                                  accentColor: 'rgb(235, 133, 0)',
                                  filter: 'hue-rotate(0deg) brightness(1.1)'
                                }}
                              />
                              <label 
                                htmlFor={`perm-${pagina.nome}`}
                                style={{ 
                                  fontSize: 13, 
                                  color: '#333',
                                  cursor: isGerenteTI ? 'not-allowed' : 'pointer',
                                  userSelect: 'none',
                                  flex: 1
                                }}
                              >
                                {pagina.label}
                              </label>
                            </div>
                          ))}
                        </div>
                        
                        <small className="form-hint" style={{ marginTop: 8, display: 'block', color: '#333' }}>
                          {PAGINAS_SISTEMA.filter(p => paginasSelecionadas[p.nome]).length} de {PAGINAS_SISTEMA.length} páginas selecionadas
                          {isGerenteTI && ' + 2 páginas de gerenciamento de funcionários'}
                          {isGerente && permissoesFuncionarios.CadastrarUsuario && permissoesFuncionarios.GerenciarFuncionarios && ' + 2 páginas de gerenciamento de funcionários'}
                          {isGerente && permissoesFuncionarios.CadastrarUsuario && !permissoesFuncionarios.GerenciarFuncionarios && ' + 1 página de gerenciamento de funcionários'}
                          {isGerente && !permissoesFuncionarios.CadastrarUsuario && permissoesFuncionarios.GerenciarFuncionarios && ' + 1 página de gerenciamento de funcionários'}
                        </small>
                      </>
                    );
                  })()}
                </div>
              )}

              {/* Botões */}
              <div className="popup-actions">
                <button type="button" className="btn-cancelar" onClick={handleClosePopup} disabled={loading}>
                  Cancelar
                </button>
                <button 
                  type="submit" 
                  className="btn-criar-conta" 
                  disabled={loading || !passwordRules(formData.senha).every(r => r.ok) || (formData.confirmarSenha && formData.senha !== formData.confirmarSenha)}
                >
                  {loading ? '⏳ Criando...' : 'Criar Conta'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Popup de Adicionar Cargo */}
      {showCargoPopup && (
        <div className="popup-overlay popup-cargo-overlay" onClick={handleCloseCargoPopup}>
          <div className="popup-content popup-cargo" onClick={(e) => e.stopPropagation()}>
            <button className="popup-close" onClick={handleCloseCargoPopup}>×</button>
            
            <div className="popup-header">
              <h3>➕ Adicionar Novo Cargo</h3>
              <p>Crie um novo cargo para seus funcionários</p>
            </div>

            {cargoError && <div className="popup-error">⚠️ {cargoError}</div>}
            {cargoSuccess && <div className="popup-success">✓ {cargoSuccess}</div>}

            <form onSubmit={handleCreateCargo} className="popup-form">
              <div className="form-section">
                <div className="form-group">
                  <label htmlFor="novoCargo">Nome do Cargo *</label>
                  <input 
                    id="novoCargo" 
                    name="novoCargo" 
                    value={novoCargo} 
                    onChange={(e) => setNovoCargo(e.target.value)} 
                    placeholder="Ex: Gerente, Supervisor, Assistente..."
                    required 
                    disabled={loadingCargo} 
                    autoFocus
                  />
                </div>
              </div>

              <div className="popup-actions">
                <button type="button" className="btn-cancelar" onClick={handleCloseCargoPopup} disabled={loadingCargo}>
                  Cancelar
                </button>
                <button type="submit" className="btn-criar-conta" disabled={loadingCargo || !novoCargo.trim()}>
                  {loadingCargo ? '⏳ Criando...' : 'Criar Cargo'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Popup de Adicionar Nível */}
      {showNivelPopup && (
        <div className="popup-overlay popup-cargo-overlay" onClick={handleCloseNivelPopup}>
          <div className="popup-content popup-cargo" onClick={(e) => e.stopPropagation()}>
            <button className="popup-close" onClick={handleCloseNivelPopup}>×</button>
            
            <div className="popup-header">
              <h3>➕ Adicionar Novo Nível</h3>
              <p>Crie um novo nível de acesso para seus funcionários</p>
            </div>

            {nivelError && <div className="popup-error">⚠️ {nivelError}</div>}
            {nivelSuccess && <div className="popup-success">✓ {nivelSuccess}</div>}

            <form onSubmit={handleCreateNivel} className="popup-form">
              <div className="form-section">
                <div className="form-group">
                  <label htmlFor="novoNivel">Nome do Nível *</label>
                  <input 
                    id="novoNivel" 
                    name="novoNivel" 
                    value={novoNivel} 
                    onChange={(e) => setNovoNivel(e.target.value)} 
                    placeholder="Ex: Supervisor, Analista, Estagiário..."
                    required 
                    disabled={loadingNivel} 
                    autoFocus
                  />
                </div>
              </div>

              <div className="popup-actions">
                <button type="button" className="btn-cancelar" onClick={handleCloseNivelPopup} disabled={loadingNivel}>
                  Cancelar
                </button>
                <button type="submit" className="btn-criar-conta" disabled={loadingNivel || !novoNivel.trim()}>
                  {loadingNivel ? '⏳ Criando...' : 'Criar Nível'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
